import { OData } from "@odata/OData";
import DialogPage from "@pages/DialogPage";
import { IGetDefinition } from "@pages/PageUtils";
import React, { ComponentType } from "react";
import { WithTranslation } from "react-i18next";

import { PageViewMode } from "../../../enums";
import { TableStorage } from "../../../model/TableStorage";
import { FormStorage } from "../../../views/formView/FormStorage";
import Dialog from "../../dialog/Dialog";
import { ISelectionTableViewProps } from "./SelectionTableViewBase";

export interface IProps extends Pick<ISelectionTableViewProps, "selectedItems" | "headerData" | "title" | "onClose" | "onSelection" | "isSingleSelect" | "isRowWithoutAction"> {
    storage?: FormStorage;
    oData?: OData;
    t?: WithTranslation["t"];

    getDefinition: IGetDefinition;
    tableView: ComponentType<ISelectionTableViewProps>;
    initializeStorage?: (storage: TableStorage) => void;
}

const SelectionTableViewDialog: React.FC<IProps> = (props) => {
    const {
        storage, oData, t,
        tableView,
        initializeStorage,
        selectedItems,
        getDefinition,
        title,
        headerData,
        onClose,
        onSelection,
        isSingleSelect,
        isRowWithoutAction
    } = props;
    return (
        <Dialog isEditableWindow
                onConfirm={null}
                onClose={onClose}>

            <DialogPage
                    pageViewMode={PageViewMode.FormReadOnly}
                    rootStorage={storage}
                    oData={oData}
                    t={t}
                    tableView={tableView}
                    initializeStorage={initializeStorage}
                    tableViewProps={{
                        onClose,
                        onSelection,
                        title,
                        selectedItems,
                        headerData,
                        isSingleSelect,
                        isRowWithoutAction
                    }}
                    getDef={getDefinition}
            />
        </Dialog>
    );
};

export default SelectionTableViewDialog;
